import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Sanitizes HTML content before binding to [innerHTML].
 * Usage: <div [innerHTML]="rawHtml | safeHtml"></div>
 *
 * Uses DomSanitizer.sanitize() which strips dangerous tags/attributes
 * (script, on*, javascript: URLs) while preserving safe formatting markup.
 */
@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) { return ''; }
    return this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
  }
}
